export const isSpring = (): boolean => {
  const currentURL = window.location.href;
  return currentURL.includes("spring");
};
